var dataJson = null;
var mensagens = null;
var msgs = 0;
var $notificacoes = $('#qtdNotificacoes');
var objs = {};
var enderecoNotificacoes = "https://api.unip.br/sistemas/notificacao/v5/servico/";

$(document).on("load",function(){
    avisosEAlertas();
});

function envelopeNotificacao__click() {
    $(".icone-notificacao").off('click').on("click", function(){

        if($(".dropdown-notifica").hasClass('ativo')){
            $(".dropdown-notifica").removeClass('ativo');
            $(".notificacao-corner").removeClass('ativo');   
        }else{
            setTimeout(function(){
                $(".dropdown-notifica").toggleClass('ativo');
                $(".notificacao-corner").toggleClass('ativo');    
            },100)
        }
    });
}

function avisosEAlertas() {
    return null;
    mensagens = JSON.parse(sessionStorage.getItem("mensagens"));
    dataJson = sessionStorage.getItem("UNIP:User") ? JSON.parse(sessionStorage.getItem("UNIP:User")) : '';

    msgs = 0;
    setTimeout(function() {
        envelopeNotificacao__click();
    }, 150);
    

    if (window.location.hostname.split("200.").length > 1 || window.location.hostname.includes("homologacaoit") || window.location.hostname.includes("localhost")) {
        enderecoNotificacoes = "https://sistemashomologacao.suafaculdade.com.br/notificacao/api/servico/";
    }

    if (validarSeNovoUsuario()) {
        
        $.ajax({
            url: enderecoNotificacoes + 'mensagemaluno/sincronizar',
            headers: {
                token: dataJson.token
            },
            type: 'GET',
            success: function (data) {
                
                if (data != null) {
                    sessionStorage.setItem("mensagens", JSON.stringify(data));
                    mensagens = data;

                    $('#qtdNotificacoes').html(msgs);

                    var message = mensagens.filter(function (x) {
                        return x.status !== "Excluido";
                    }).length;


                    if (message == 0) {
                        naoPossuiNotificacoes();
                        return;
                    }

                    if (data)
                        data.sort(comparePrioridade);

                    $.each(data, function (index, item) {
                        if (item.status === "Ativo" && item.lido === false) {
                            MontarMensagensModal(item);

                            msgs += 1;
                            $('#qtdNotificacoes').html(msgs);
                        }

                        if (item.status !== "Excluido") {
                            MontarMensagensNotificacao(item);
                        }
                    });

                    VincularClickDeFechar();

                    if (msgs > 0)
                        $('#qtdNotificacoes').css('display', 'block');

                    VincularClickNotificacoes();
                    VincularClickDeDeletar();
                    VerificarModal();
                    envelopeNotificacao__click();
                } else {
                    naoPossuiNotificacoes();
                    return;
                }
            },
            error: function (err) {
                naoPossuiNotificacoes();
            }
        });

    }
    else if (mensagens && dataJson) {
        $('#qtdNotificacoes').html(msgs);
        var message;
        if (mensagens) {
            message = mensagens.filter(function (x) {
                return x.status !== "Excluido";
            }).length;
        }

        if (message == 0 || mensagens === null) {
            naoPossuiNotificacoes();
            return;
        }

        if (mensagens)
            mensagens.sort(comparePrioridade);


        if (message == 0) {
            naoPossuiNotificacoes();
            return;
        }

        $.each(mensagens, function (index, item) {
            if (item.status === "Ativo" && item.lido === false) {
                MontarMensagensModal(item);
                msgs += 1;
                $('#qtdNotificacoes').html(msgs);
                $('#qtdNotificacoes').css("display","block");
            }

            if (item.status !== "Excluido") {
                MontarMensagensNotificacao(item);
            }
        });

        VincularClickDeFechar();

        if (msgs > 0)
            $('#qtdNotificacoes').css('display', 'block');

        VincularClickNotificacoes();
        VincularClickDeDeletar();
        VerificarModal();
    }
}

function validarSeNovoUsuario(){

    if(mensagens){
        if(mensagens.length > 0){ 
            if(mensagens[0].ra === dataJson.identificacao){
                return false;
            }
        }
    }

    return true;
}

function VerificarModal() {
    if (mensagens) {

        var msgsAtivas = mensagens.find(function (x) {
            return x.status === "Ativo" && x.lido === false;
        });

        // Apenas alunos com mensagem ativa aparece a modal
        if (msgsAtivas) {
            $('#modalPai').modal({ show: true });
        }
    }
}

function MontarMensagensModal(mensagem) {
    
    if (mensagem.Video)
        MontarMensagensModalComVideo(mensagem);
    else
        MontarMensagensModalSemVideo(mensagem);
}

function MontarMensagensModalSemVideo(mensagem) {
    var template = 
        '<div class=" modal-avisos" id="' + mensagem.id + '">' +
            '<div class="modal-dialog modal-dialog-avisos mt-0" role="document">' +
                '<div class="modal-content">' +
                    '<div class="modal-header">' +
                        '<h6 class="mb-0 mt-1">' + mensagem.mensagem.titulo + '</h6>' +
                        '<button type="button" class="close" aria-label="Close" ref="' + mensagem.id + '"><span aria-hidden="true">&times;</span></button>' +
                    '</div>' +
                    '<div class="modal-body">' +
                        '<i class="far fa-clock mr-2" aria-hidden="true"></i><span style="font-size:1rem; font-weight:normal;" class="modal-mensagem mb-2">Data do aviso: <span style="color:#2b3d7e;">' + formatarData(mensagem.criadoEm) + '</span></span><br>' +
                        '<span data-ref="' + mensagem.mensagem.referencia + '">' + mensagem.mensagem.texto + '</span>' +
                        `<div class="form-check text-right" style="display:${mensagem.mensagem.referencia === "ACORDO_ALUNOS" ? "block" : "none"};" ><span>` +
                            `<input type="checkbox" data-id="${mensagem.id}" class="form-check-input acordo-aluno">` +
                            '<label class="form-check-label" for="exampleCheck1" style="font-weight: normal !important;">Entendi e não tenho interesse</label>' +
                        '</span></div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>';


    $('#modalAvisos').append(template);

}

function MontarMensagensModalComVideo(mensagem) {
    var template = 
        '<div class=" modal-avisos" id="' + mensagem.id + '">' +
        '<div class="modal-dialog modal-dialog-avisos" role="document">' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '<button type="button" class="close" aria-label="Close" ref="' + mensagem.id + '"><span aria-hidden="true">&times;</span></button>' +
        '</div>' +
        '<div class="modal-body">' +
        '<h6>' + mensagem.mensagem.titulo + '</h6>' +
        '<span style="font-size:20px; font-weight:normal;padding: 0 10px;" class="modal-mensagem mb-2">Data do aviso: <span style="color:#2b3d7e;">' + formatarData(mensagem.criadoEm) + '</span></span><br>' +
        '<span>' + mensagem.mensagem.texto + '</span>' +
        '</div>' +
        '<div class="modal-footer">' +
        '<button type="button" class="video-modal-' + mensagem.id + ' btn btn-primary">ASSISTIR AO VÍDEO</button>' +
        '<div class="video-container video-container-modal-' + mensagem.id + ' text-center" style="display:none;">' +
        '<video id="videoModal-' + mensagem.id + '" class="azuremediaplayer amp-default-skin" autoplay controls height="240" poster=""></video> ' +
        '<source src="' + mensagem.video + '" type="application/vnd.ms-sstr+xml" /> ' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';


    $('#modalAvisos').append(template);
    MontarVideoModal(mensagem);
}

function VincularClickDeFechar() {
    
    // Ao clicar em fechar a modal de dentro, verifica qual modal foi clicada para fazer um FadeOUT.
    $('.close').on('click', function () {
        var id = $(this).attr('ref');
        var avisoModal = $(this).parent().parent().parent().parent();
        avisoModal.fadeOut();
        setTimeout(function () {
            if(avisoModal.parent().children().length == 1 ){
                $("#modalPai").modal("hide");
            }
            avisoModal.remove();
            
        },500);

        // DesativarMensagem(id);       
        $(".dropdown-item.actived#mensagem-" + id + ", .dropdown-item.actived#mensagem-" + id + "-m").trigger('click');
    });
}

function VincularClickDeDeletar() {
    // Ao clicar em fechar a modal de dentro, verifica qual msg foi clicada para fazer um FadeOUT.
    $('.deletar-mensagem').on('click', function (event) {
        var id = $(this).attr('ref');
        DeletarMensagem(id);
    });
}

function DesativarMensagem(id) {
    $('.loader-double').remove();
    $.ajax({
        url: enderecoNotificacoes + 'mensagemaluno/marcarleitura/' + id,
        headers: {
            token: dataJson.token
        },
        type: 'PUT',
        success: function (data) {
            $('#' + id).fadeOut(300, function () {
                //$('#' + id).remove();
                if ($('#modalPai .close').length == 0) {
                    $('#modalPai').modal('hide');
                }
            });

        },
        error: function () {
            // alert('Ocorreu um erro ao desativar a mensagem!');
        }
    });
}

function DeletarMensagem(id) {
    $('.loader-double').remove();
    $.ajax({
        url: enderecoNotificacoes + "mensagemaluno/" + id,
        headers: {
            token: dataJson.token
        },
        type: 'DELETE',
        success: function (data) {
            RemoverMensagemDaSessao(id);
            $('#mensagem-' + id).fadeOut(300);
            $('#mensagem-' + id + '-m').fadeOut(300);
            $('.deletar-mensagem[ref="'+id+'"]').fadeOut(300);

            if (mensagens.length === 0 || mensagens === null)
            {                
                naoPossuiNotificacoes();
            }

            var n = mensagens.filter(function (x) {
                return x.status === "Ativo" && x.lido === false;
            }).length;

            $('#qtdNotificacoes').html(n);

            if (n == 0)
                $('#qtdNotificacoes').css('display', 'none');
        },
        error: function () {
            // alert('Ocorreu um erro ao deletar a mensagem!');
        }
    });
}

function MontarMensagensNotificacao(item) {

    if (item.Video)
        MontarMensagensNotificacaoComVideo(item);
    else
        MontarMensagensNotificacaoSemVideo(item);
}

function MontarMensagensNotificacaoSemVideo(item) {
    var ativo = item.status === "Ativo" && item.lido === false ? 'actived' : 'visualizado';

    var fixa = item.mensagem.fixa === "N" ? '<button type="button" class="deletar-mensagem text-danger" ref="' + item.id + '">Deletar <i class="fas fa-trash text-danger" aria-hidden="true"></i></button>' : "";

    var template = 
        '<li id="mensagem-' + item.id + '" ref="' + item.id + '" style="white-space: initial;" class="dropdown-item ' + ativo + ' ">' +
        fixa +
        '<h6>' + item.mensagem.titulo + '</h6>' +
        '<span class="modal-mensagem mb-2">Data do aviso: <span class="data-mensagem" style="color:#2b3d7e;">' + formatarData(item.criadoEm) + '</span></span><br>' +
        '<div class="no-padding">' +
        '<span data-ref="' + item.mensagem.referencia + '"><span>' + item.mensagem.texto + '</span></span>' +
        `<div class="form-check text-right" style="display:${item.mensagem.referencia === "ACORDO_ALUNOS" ? "block" : "none"};" ><span>` +
        `<input type="checkbox" data-id="${item.id}" class="form-check-input acordo-aluno">` +
        '<label class="form-check-label" for="exampleCheck1" style="font-weight: normal !important;">Entendi e não tenho interesse</label>' +
        '</span></div>' +
        '</div>' +
        '</li>';

    $('.notificacao').append(template);

	fixa = item.mensagem.fixa === "N" ? '<button type="button" class="deletar-mensagem text-danger" ref="' + item.id + '">Deletar <i class="fas fa-trash text-danger" aria-hidden="true"></i></button>' : "";
	
    template = 
        '<li id="mensagem-' + item.id + '-m" ref="' + item.id + '" style="white-space: initial;" class="dropdown-item ' + ativo + ' ">' +
        fixa +
        '<h6>' + item.mensagem.titulo + '</h6>' +
        '<div class="no-padding">' +
        '<span data-ref="' + item.mensagem.referencia + '"><span>' + item.mensagem.texto + '</span></span><br>' +
        '<hr></div>' +
        '</li>';

}

function MontarMensagensNotificacaoComVideo(item) {

    var ativo = item.status === "Ativo" && item.lido === false ? 'actived' : 'visualizado';

    var fixa = item.mensagem.fixa === "N" ? '<button type="button" class="deletar-mensagem text-danger" ref="' + item.id + '">Deletar <i class="fas fa-trash text-danger" aria-hidden="true"></i></button>' : "";

    var template = 
        '<li id="mensagem-' + item.id + '" ref="' + item.id + '" style="white-space: initial;" class="dropdown-item ' + ativo + ' ">' +
        fixa +
        '<h6>' + item.titulo + '</h6>' +
        '<span class="modal-mensagem mb-2">Data do aviso: <span class="data-mensagem" style="color:#2b3d7e;">' + formatarData(mensagem.criadoEm) + '</span></span><br>' +
        '<div class="no-padding">' +
        '<span>' + item.texto +
        '</span>' +
        '</div>' +
        '<a href="#"><button type="button" class="video-' + item.id + ' btn btn-primary">ASSISTIR AO VÍDEO</button></a>' +
        '<div class="video-container-' + item.id + ' text-center" style="display:none;">' +
        '<video id="video-' + item.id + '" class="azuremediaplayer amp-default-skin" autoplay controls height="240" poster=""></video> ' +
        '<source src="' + item.video + '" type="application/vnd.ms-sstr+xml" /> ' +
        '</div>' +
        '</li>';

    $('.notificacao').append(template);
    MontarVideoNotificacao(item);

    template = '<button type="button" class="deletar-mensagem text-danger" ref="' + item.id + '"><span aria-hidden="true">&times;</span></button>' +
        '<li id="mensagem-' + item.id + '-m" ref="' + item.id + '" style="white-space: initial;" class="dropdown-item ' + ativo + ' ">' +
        '<div class="no-padding">' +
        '<span>' + item.texto +
        '</span>' +
        '</div>' +
        '<a href="#"><button type="button" class="video-' + item.id + '-m btn btn-primary">ASSISTIR AO VÍDEO</button></a>' +
        '<div class="video-container-' + item.id + '-m text-center" style="display:none;">' +
        '<video id="video-' + item.id + '-m" class="azuremediaplayer amp-default-skin" autoplay controls height="240" poster=""></video> ' +
        '<source src="' + item.video + '" type="application/vnd.ms-sstr+xml" /> ' +
        '</div>' +
        '</li>';

    MontarVideoNotificacaoMobile(item);
}

function MontarVideoNotificacao(item) {
    objs['video-' + item.id] = amp('video-' + item.id + '', { /* Options */
        techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"],
        nativeControlsForTouch: false,
        width: "100%",
        controls: true,
        autoplay: false,
        logo: { "enabled": false }
    });

    objs['video-' + item.id].src([{
        src: item.video,
        type: "application/vnd.ms-sstr+xml"
    }]);

    $('.video-' + item.id + '').click(function (event) {
        event.preventDefault();
        if ($(this).text() == "FECHAR O VÍDEO") {
            $(this).text("ASSISTIR AO VIDEO");
            objs['video-' + item.id].pause();
        } else {
            $(this).text("FECHAR O VÍDEO");
            objs['video-' + item.id].play();
        }
        $('.video-container-' + item.id).animate({
            height: "toggle"
        }, 500);
    });
}

function MontarVideoModal(item) {
    objs['videoModal-' + item.id] = amp('videoModal-' + item.id + '', { /* Options */
        techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"],
        nativeControlsForTouch: false,
        width: "100%",
        controls: true,
        autoplay: false,
        logo: { "enabled": false }
    });

    objs['videoModal-' + item.id].src([{
        src: item.video,
        type: "application/vnd.ms-sstr+xml"
    }]);

    $('.video-modal-' + item.id + '').click(function (event) {
        event.preventDefault();

        if ($(this).text() == "FECHAR O VÍDEO") {
            $(this).text("ASSISTIR AO VIDEO");
            objs['videoModal-' + item.id].pause();
        } else {
            $(this).text("FECHAR O VÍDEO");
            objs['videoModal-' + item.id].play();
        }
        $('.video-container-modal-' + item.id).animate({
            height: "toggle"
        }, 500);
    });
}

function MontarVideoNotificacaoMobile(item) {
    objs['video-' + item.id + '-m'] = amp('video-' + item.id + '-m', { /* Options */
        techOrder: ["azureHtml5JS", "flashSS", "html5FairPlayHLS", "silverlightSS", "html5"],
        nativeControlsForTouch: false,
        width: "100%",
        controls: true,
        autoplay: false,
        logo: { "enabled": false }
    });

    objs['video-' + item.id + '-m'].src([{
        src: item.video,
        type: "application/vnd.ms-sstr+xml"
    }]);

    $('.video-' + item.id + '-m').click(function (event) {
        event.preventDefault();
        if ($(this).text() == "FECHAR O VÍDEO") {
            $(this).text("ASSISTIR AO VIDEO");
            objs['video-' + item.id + '-m'].pause();
        } else {
            $(this).text("FECHAR O VÍDEO");
            objs['video-' + item.id + '-m'].play();
        }
        $('.video-container-' + item.id + '-m').animate({
            height: "toggle"
        }, 500);
    });
}

function VincularClickNotificacoes() {
    $(".modal-body").click((event) => {
        event.preventDefault();
        event.stopPropagation();

        let Id = $(event.target).parents(".modal-avisos").attr("id");
        if ($(event.target).parents("span").data("ref") === "ACORDO_ALUNOS") {
            confirmarLeituraAcordo();
            DesativarMensagem(Id);
            AtualizarDadosNaSessao(Id);
            //$(`#${Id}.modal-avisos`).remove();
            //$(`#mensagem-${Id}`).remove();
            //$(`#mensagem-${Id}`).prev("button").remove();
            let alertNumber = parseInt($($(".badge-notificacoes")[0]).text());
            alertNumber--;
            if (alertNumber > 0) {
                $('.badge-notificacoes').html(alertNumber);
            } else {
                $('.badge-notificacoes').css('display', 'none');
                $('.badge-notificacoes').text(0);
            }
            window.open($(event.target).attr("href"), '_blank');
        }
    });

    $(".acordo-aluno").click((event) => {
        let Id = $(event.target).parents(".dropdown-item.actived").attr('ref') || $(event.target).parents(".modal-avisos").attr("id");
        DesativarMensagem(Id);
        AtualizarDadosNaSessao(Id);
        //$(`#${Id}.modal-avisos`).remove();
        //$(`#mensagem-${Id}`).remove();
        //$(`#mensagem-${Id}`).prev("button").remove();
        let alertNumber = parseInt($($(".badge-notificacoes")[0]).text());
        alertNumber--;
        if (alertNumber > 0) {
            $('.badge-notificacoes').html(alertNumber);
        } else {
            $('.badge-notificacoes').css('display', 'none');
            $('.badge-notificacoes').text(0);
        }
    });

    $('.dropdown-item').click(function (event) {
        event.stopPropagation();
    });

    $(".dropdown-item.actived").click(function (event) {
        //event.preventDefault();
        //event.stopPropagation();

        if ($(this).hasClass('actived')) {
            var Id = $(this).attr('ref');

            AtualizarDadosNaSessao(Id);
            if ($(event.target).parents("span").data("ref") === "ACORDO_ALUNOS") {
                confirmarLeituraAcordo();
            }

            DesativarMensagem(Id);

            $(this).removeClass('actived');
            $(this).addClass('visualizado');

            var n = mensagens.filter(function (x) {
                return x.status === "Ativo" && x.lido === false;
            }).length;

            $('.badge-notificacoes').text('');
            if (n > 0) {
                $('.badge-notificacoes').text(n);
            } else {
                $('.badge-notificacoes').css('display', 'none');
                $('.badge-notificacoes').text(0);

            }

        }
    });
}

function AtualizarDadosNaSessao(Id) {
    mensagens = JSON.parse(sessionStorage.getItem("mensagens"));
    var retorno = mensagens.find(function (x) {
        return x.id == Id;
    });

    retorno.status = "Inativo";
	retorno.lido = true;

    var filtrado = mensagens.filter(function (x) {
        return x.id != Id;
    });

    filtrado.push(retorno);
    mensagens = filtrado;
    sessionStorage.setItem("mensagens", JSON.stringify(filtrado));
}

function RemoverMensagemDaSessao(Id) {
    mensagens = JSON.parse(sessionStorage.getItem("mensagens"));

    var filtrado = mensagens.filter(function (x) {
        return x.id != Id;
    });

    mensagens = filtrado;
    sessionStorage.setItem("mensagens", JSON.stringify(filtrado));
}

function compare(a, b) {
    if (a.mensagem.prioridade < b.mensagem.prioridade)
        return -1;
    if (a.mensagem.prioridade > b.mensagem.prioridade)
        return 1;
    return 0;
}

function comparePrioridade(a, b) {
    return a.mensagem.prioridade - b.mensagem.prioridade;
}

function formatarData(data) {

    let dataHora = data.split(" ");
    if(data.indexOf('T') > 0) {
        dataHora = data.split('T');
    }
    let diaMesAno = dataHora[0].split("-");
    return `${diaMesAno[2]}/${diaMesAno[1]}/${diaMesAno[0]}`;
}

function naoPossuiNotificacoes() {
    $('.notificacao').append('<li class="dropdown-item"><span>Você não possui mensagens.</span></li>');
}

function confirmarLeituraAcordo() {
    let user = "";
    let token = "";
    if (sessionStorage.getItem("UNIP:User")) {
        user = JSON.parse(sessionStorage.getItem("UNIP:User"));
        token = user.token;
    }

    $.ajax({
        url: enderecoNotificacoes + "lyceum",
        headers: {
            token: token
        },
        type: 'POST',
        success: function (data) { }
    });
}